import React, { FC } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import ResourceLibraryList from '../../../../sales-kit/components/Library/pages/List';
import { HAPPY_SHARE_MATERIAL_BASE_PATH, HAPPY_SHARE_LIBRARY_BASE_PATH } from '../../../constants';
import { ModulePermissionProps } from '../../../../../common/module/types';
import { SALESKIT_BASE_PATH } from 'src/app/modules/sales-kit/constants';

export const SystemConfig = {
  filterName: 'component.filterTitle.happy-share-material',
  blockName: 'component.formTitle.happy-share-material',
  blockType: 'happyShareMaterial',
  moduleType: 'HappyShare',
  //PHKL Custom - s
  createPagePath: `${SALESKIT_BASE_PATH}${HAPPY_SHARE_MATERIAL_BASE_PATH}${HAPPY_SHARE_LIBRARY_BASE_PATH}/create`,
  editPageBasePath: `${SALESKIT_BASE_PATH}${HAPPY_SHARE_MATERIAL_BASE_PATH}${HAPPY_SHARE_LIBRARY_BASE_PATH}/edit`,
  viewPageBasePath: `${SALESKIT_BASE_PATH}${HAPPY_SHARE_MATERIAL_BASE_PATH}${HAPPY_SHARE_LIBRARY_BASE_PATH}/view`,
  performancePagePath: `${SALESKIT_BASE_PATH}${HAPPY_SHARE_MATERIAL_BASE_PATH}${HAPPY_SHARE_LIBRARY_BASE_PATH}/performance`,
  //PHKL Custom - e
};

const HappyShareLibraryListPage: FC<RouteComponentProps & ModulePermissionProps> = (props) => {
  return <ResourceLibraryList {...props} {...SystemConfig} />;
};

export default HappyShareLibraryListPage;
